export default "__VITE_ASSET__50fd73d5__"